/* eslint-disable */
import type { SVGProps } from 'react';
import { memo } from 'react';

const SH = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="1000"
    height="600"
    viewBox="0 0 1000 600"
    {...props}
  >
    <rect
      id="blue_stripe"
      width="1000"
      height="200"
      fill="#0039ad"
    />
    <rect
      id="white_stripe"
      width="1000"
      height="200"
      y="200"
      fill="#fff"
    />
    <rect
      id="red_stripe"
      width="1000"
      height="200"
      y="400"
      fill="#d61810"
    />
  </svg>
);
export default memo(SH);
